import React from 'react'
import crefito from '../../assets/brasao.png'
import './DespachoView.css'

const converterData = (data) => {
  const [ano, mes, dia] = data.split("-")

  const dataFormatada = `${dia}/${mes}/${ano}`

  return dataFormatada
}

const DespachoView = ({ despacho, processo }) => {
  return (
    <>
      <div className="caixaDespachoJuridico">
        <div className="cabecalhoDespachoJuridico">
          <div>
            <img src={crefito} alt="crefito" className="brasil mt-4" />
          </div>
          <div>Conselho Regional de Fisioterapia e Terapia Ocupacional da 1ª Região</div>
          <div>CREFITO-1</div>
          <div>Circunscrição: AL/PB/PE/RN</div>
        </div>

        <h2 className="despachoJuridico">Despacho</h2>
        <div className="topoJuridico">
          {processo?.numero && processo?.dataCriacao && (
            <div>Processo nº {processo.numero}/{processo.dataCriacao.slice(0, 4)}</div>
          )}
          {/* {despacho?.idUserDestino?.nome ? (
            <div>Destino: {despacho.idUserDestino?.nome}</div>
          ) : (
            <div>Destino:
              {despacho?.setor === "Aguardando Prazo"
                ? `Aguardando Prazo (${converterData(despacho.prazo?.slice(0, 10))})`
                : despacho?.setor || "Não foi dado Despacho"}
            </div>
          )} */}
        </div>
        <div className="paragrafoJuridico">
          <p>{despacho?.texto || ''}</p>
        </div>
        <div className="identificacaoJuridico">
          _________________________________________________________________
          <p>{despacho?.idUserCriador?.nome ? despacho.idUserCriador.nome : ''}</p>
        </div>
      </div>
    </>
  )
}

export default DespachoView
